import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"

const EditVlccSettings = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [purchase, setPurchase] = useState([])
  const [chillings, setChillings] = useState([])
  const [routes, setRoutes] = useState([])
  const [collections, setCollections] = useState([])
  const [producers, setProducers] = useState([])
  const [entryMode, setEntryMode] = useState("")

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.put("update-vlcc-purchase/" + id, values)
    if (response.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    //const recResp = await api.get('vlcc-purchase/'+id)
    const chilResp = await api.get("centers")
    const rouResp = await api.get("routes")
    const ccResp = await api.get("collection-centers")
    const proResp = await api.get("producers")
    //setPurchase(recResp.data.data[0]);
    setChillings(Array.isArray(chilResp.data.data) ? chilResp.data.data : chilResp.data.data?.data || [])
    setRoutes(Array.isArray(rouResp.data.data) ? rouResp.data.data : rouResp.data.data?.data || [])
    setCollections(Array.isArray(ccResp.data.data) ? ccResp.data.data : ccResp.data.data?.data || [])
    setProducers(Array.isArray(proResp.data.data) ? proResp.data.data : proResp.data.data?.data || [])
    //    setEntryMode(recResp.data.data[0].entryMode);
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit VLCC Settings</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/vlcc-purchases" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v, "create")
            }}
          >
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="chillingCenter"
                    label="Chilling Center"
                    required
                    value={purchase.chillingCenter}
                  >
                    <option value="">Select Chilling Center</option>
                    {chillings.map((chilling, i) => (
                      <option key={i} value={chilling.id}>
                        {chilling.name}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="route"
                    value={purchase.route}
                    label="Route"
                    required
                  >
                    <option value="">Select Route</option>
                    {routes.map((route, i) => (
                      <option key={i} value={route.id}>
                        {route.routeName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="collectionCenter"
                    value={purchase.collectionCenter}
                    label="Collection Center"
                    required
                  >
                    <option value="">Select Collection Center</option>
                    {collections.map((collection, i) => (
                      <option key={i} value={collection.id}>
                        {collection.centerName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="producer"
                    value={purchase.producer}
                    label="Producer"
                    required
                  >
                    <option value="">Select Producer</option>
                    {producers.map((producer, i) => (
                      <option key={i} value={producer.id}>
                        {producer.producerName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="purchaseDate"
                    label="Purchase Date"
                    value={purchase.purchaseDate}
                    className="form-control"
                    type="date"
                    required
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <AvRadioGroup
                    inline
                    name="shift"
                    value={purchase.shift}
                    label="Shift "
                    required
                    errorMessage="Pick one!"
                  >
                    <AvRadio label="AM" value="0" />
                    <AvRadio label="PM" value="1" />
                  </AvRadioGroup>
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="serialNo"
                    label="Serial Number"
                    value={purchase.serialNo}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvRadioGroup
                    inline
                    name="milkType"
                    label="Milk Type"
                    value={purchase.milkType}
                    required
                    errorMessage="Pick one!"
                  >
                    <AvRadio label="Cow" value="1" />
                    <AvRadio label="Buffalo" value="2" />
                  </AvRadioGroup>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="qtyLtrs"
                    label="Purchase Quantity"
                    value={purchase.qtyLtrs}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="purchaseFat"
                    label="Purchase Fat"
                    value={purchase.purchaseFat}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvRadioGroup
                    inline
                    name="entryMode"
                    value={purchase.entryMode}
                    label="Entry Mode"
                    required
                    errorMessage="Pick one!"
                    onChange={e => setEntryMode(e.target.value)}
                  >
                    <AvRadio label="SNF" value="1" />
                    <AvRadio label="CLR" value="2" />
                  </AvRadioGroup>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="purchaseSnf"
                    label="Purchase Snf"
                    value={purchase.purchaseSnf}
                    className="form-control"
                    type="text"
                    readOnly={entryMode == "1" ? true : false}
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="purchaseClr"
                    label="Purchase CLR"
                    value={purchase.purchaseClr}
                    className="form-control"
                    type="text"
                    readOnly={entryMode == "2" ? true : false}
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="purchaseCans"
                    label="Purchase Cans"
                    value={purchase.purchaseCans}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="temperature"
                    label="Temperature"
                    value={purchase.temperature}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="waterPercent"
                    label="Water Percent"
                    value={purchase.waterPercent}
                    className="form-control"
                    type="text"
                    required
                  />
                </div>
              </Col>
            </Row>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Vendor purchase is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update purchase </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditVlccSettings
